import React from "react";
import Avatar from "@mui/material/Avatar";
import { styled } from "@mui/material/styles";

import { replaceImageSource } from "../helpers/withReplaceImageSource";

// Styled container span
const RootSpan = styled("span")(({ theme }) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: theme.spacing(1),
}));

const StyledAvatar = styled(Avatar)(() => ({
  width: 25,
  height: 25,
}));

const ItemDescriptionWithImageForDo = ({ images = [], description = "" }) => {
  const imageUrl = images?.length > 0 ? replaceImageSource(images[0].name) : "";

  return (
    <RootSpan>
      <StyledAvatar src={imageUrl} />
      {description}
    </RootSpan>
  );
};

export default ItemDescriptionWithImageForDo;
